import { Button } from '../surfacePrimitives.js';

export type ApproveRejectActionsProps = {
  readonly onApprove: () => void | Promise<void>;
  readonly onReject: () => void | Promise<void>;
  readonly approveLabel?: string;
  readonly rejectLabel?: string;
  readonly disabled?: boolean;
  readonly busy?: boolean;
  readonly testId?: string;
};

/**
 * Shared approve/reject actions for dual-control flows (outbox + exception-grant).
 * Not for payment claims (ADV-CLAIMS-SOD-001 — step-up only ≠ SoD #2).
 */
export function ApproveRejectActions({
  onApprove,
  onReject,
  approveLabel = 'Approve',
  rejectLabel = 'Reject',
  disabled = false,
  busy = false,
  testId = 'approve-reject-actions',
}: ApproveRejectActionsProps) {
  return (
    <div data-testid={testId} className="approve-reject-actions">
      <Button
        type="button"
        intent="primary"
        disabled={disabled || busy}
        data-testid={`${testId}-approve`}
        onClick={() => {
          void onApprove();
        }}
      >
        {approveLabel}
      </Button>
      <Button
        type="button"
        intent="secondary"
        disabled={disabled || busy}
        data-testid={`${testId}-reject`}
        onClick={() => {
          void onReject();
        }}
      >
        {rejectLabel}
      </Button>
    </div>
  );
}
